// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n6hT","textarea":"styles_textarea__Ti6Nw"};